var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{staticStyle:{"height":"70px"}},[_c('nav-bar')],1),_c('el-container',[_c('el-aside',{attrs:{"width":_vm.asideWidth}},[_c('side-bar',{staticClass:"sidebar-container"})],1),_c('el-main',[_c('app-main')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }